export enum UserGender {
  Female = 1,
  Male,
}

export const userGenders = (): Record<UserGender, string> => ({
  [UserGender.Female]: 'Female',
  [UserGender.Male]: 'Male',
})
